import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const userApiSlice = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API_BASE_URL,
  }),
  endpoints: (builder) => ({
    getUsers: builder.query({
    query: () => '/users/all?pagination=true',
    }),
  }),
});

export const { useGetUsersQuery } = userApiSlice;
